import type { CartaoAlteracaoProps } from "./types-cartao-alteracao";
import { useCartaoAlteracao } from "./use-cartao-alteracao";
import { CartaoAlteracaoView } from "./view-cartao-alteracao";

/**
 * Cartão de uma alteração (Aplicar Simulação, HU 2221): nome do recurso, tipo, linhas rótulo/valor e,
 * na remoção vinculada, o chip da substituição acima do cartão.
 */
export function CartaoAlteracao(props: CartaoAlteracaoProps) {
  const vm = useCartaoAlteracao(props);

  return <CartaoAlteracaoView {...vm} />;
}

export type * from "./types-cartao-alteracao";
